"use client";

import SectionHeader from "@/components/ui/section-header";
import EnterpriseBannerDe from "@/components/sections/de/shared/enterprise-banner";
import FeatureGrid, {
  type FeatureGridItem,
} from "@/components/sections/products/shared/feature-grid";
import {
  AccessPointsVisual,
  CarrierSignalVisual,
  CredentialsVisual,
  GeoTargetVisual,
  RotationVisual,
  SuccessRateVisual,
} from "@/components/sections/products/shared/feature-visuals";

// German clone of mobile-proxies/pricing-features — same visuals/layout,
// translated copy.
const features: FeatureGridItem[] = [
  {
    Visual: CarrierSignalVisual,
    title: "Premium Mobile IPs",
    description: "Ethisch bezogene und vollständig konforme mobile IPs.",
  },
  {
    Visual: GeoTargetVisual,
    title: "Präzises Geo-Targeting",
    description:
      "Targeting nach Land, Stadt oder Standort, mit Fastest-Option für automatische Optimierung.",
  },
  {
    Visual: SuccessRateVisual,
    title: "99,5 %+ Erfolgsquote",
    description:
      "Weniger Blocks, weniger Wiederholungen, saubere Ergebnisse bei allen gängigen Zielseiten.",
  },
  {
    Visual: RotationVisual,
    title: "Rotation & Sticky Sessions",
    description:
      "Zufällige IP-Rotation für einen frischen Exit bei jeder Verbindung, sticky Sessions für Kontinuität, oder manuelles Neuladen bei Bedarf.",
  },
  {
    Visual: AccessPointsVisual,
    title: "Unbegrenzte Access Points",
    description:
      "So viele Access Points anlegen, wie Projekte benötigen — alle aus dem gemeinsamen mobilen Pool, jederzeit erweiterbar.",
  },
  {
    Visual: CredentialsVisual,
    title: "Fertige Zugangsdaten",
    description:
      "Proxy-Listen erzeugen, Zugangsdaten kopieren, Hostname-Format wechseln und mit cURL-Beispielen schnell testen.",
  },
];

export default function MobilePricingFeaturesDe() {
  return (
    <section
      id="product-features"
      className="py-section border-border border-b"
      aria-labelledby="features-heading"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-14 max-w-2xl">
          <SectionHeader
            eyebrow="Warum Proxidize"
            id="features-heading"
            heading={<>Premium-Qualität. Keine Kompromisse.</>}
            body="Alles, was Proxidize Mobile Proxies bieten — ethisch bezogen, vollständig konform, mit den Kontrollmöglichkeiten, die zählen."
          />
        </div>

        <FeatureGrid items={features} ariaLabel="Mobile Proxy Funktionen" />

        <div className="mt-10">
          <EnterpriseBannerDe description="Individuelle Rotationsregeln, priorisierter Support, höhere Volumengrenzen und Preise ab $0,5/GB." />
        </div>
      </div>
    </section>
  );
}
